module.exports = __webpack_public_path__ + "components/rewards/twelve-day/static/logo-0f7f26eaad35afdbc2897427e6cf3736.jpg";